import React from 'react';
import styled from 'styled-components';
import { RoomSpectator } from '../../store/multiplayerSlice';
import PlayerAvatar from './PlayerAvatar';

const Wrapper = styled.div`
  background: rgba(0, 0, 0, 0.25);
  border-radius: 1.2rem;
  padding: 1.2rem 1.6rem;
  min-width: 16rem;
`;

const Title = styled.h3`
  font-size: var(--font-size-heading-xs);
  text-transform: uppercase;
  color: var(--color-white);
  margin-bottom: 0.8rem;
  opacity: 0.8;
`;

const List = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;

const Item = styled.li`
  font-size: 1.4rem;
  color: var(--color-white);
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

const SpectatorName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Empty = styled.p`
  font-size: 1.3rem;
  color: rgba(255, 255, 255, 0.5);
  font-style: italic;
`;

interface Props {
  spectators: RoomSpectator[];
}

const SpectatorList: React.FC<Props> = ({ spectators }) => {
  return (
    <Wrapper>
      <Title>👁 Spectators ({spectators.length})</Title>
      {spectators.length === 0 ? (
        <Empty>No spectators yet</Empty>
      ) : (
        <List>
          {spectators.map((s) => (
            <Item key={s.socketId}>
              <PlayerAvatar
                pfpUrl={s.pfpUrl}
                name={s.name}
                size={28}
                ringColor="rgba(255,255,255,0.4)"
              />
              <SpectatorName>
                {s.username ? `@${s.username}` : s.name}
              </SpectatorName>
            </Item>
          ))}
        </List>
      )}
    </Wrapper>
  );
};

export default SpectatorList;
